// extracted by mini-css-extract-plugin
export var active = "_8x-7";
export var container = "_8x-0";
export var evenWidth = "_8x-4";
export var large = "_8x-5";
export var outlet = "_8x-8";
export var slide = "_8x-2";
export var small = "_8x-6";
export var tab = "_8x-3";
export var tabs = "_8x-1";